import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

const SidebarLink = ({ route }) => {
  const location = useLocation();
  const isActive = location.pathname === `/admin/${route.path}`;
  const [isOpen, setIsOpen] = useState(false);

  const linkClasses = `flex items-center px-4 py-3 rounded-lg transition-colors ${
    isActive
      ? "bg-primary/10 text-primary dark:text-white"
      : "text-gray-600 hover:bg-gray-100 dark:hover:bg-navy-700"
  }`;

  return (
    <div className="mb-2">
      {route.subRoutes ? (
        <>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`${linkClasses} w-full justify-between`}
          >
            <div className="flex items-center">
              <span className="mr-3">{route.icon}</span>
              <span className="font-medium">{route.name}</span>
            </div>
            {isOpen ? <MdExpandLess /> : <MdExpandMore />}
          </button>

          {isOpen && (
            <div className="ml-8 mt-1 space-y-1">
              {route.subRoutes.map((subRoute) => (
                <Link
                  key={subRoute.path}
                  to={`/admin/${route.path}/${subRoute.path}`}
                  className="block px-4 py-2 text-sm text-gray-600 hover:text-primary dark:text-gray-400"
                >
                  {subRoute.name}
                </Link>
              ))}
            </div>
          )}
        </>
      ) : (
        <Link to={`/admin/${route.path}`} className={linkClasses}>
          <span className="mr-3">{route.icon}</span>
          <span className="font-medium">{route.name}</span>
        </Link>
      )}
    </div>
  );
};

const SidebarLinks = ({ routes }) => {
  return (
    <div className="space-y-1">
      {routes.map((route) => (
        <SidebarLink key={route.path} route={route} />
      ))}
    </div>
  );
};

export default SidebarLinks;
